import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import CtBtn from "../Components/CustomTool/CtBtn";
import CtDtp from "./CustomTool/CtDtp";
import CtMultiLineText from "../Components/CustomTool/CtMultiLineText";
import CtCmbEditable from "../Components/CustomTool/CtCmbEditable";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { withRouter } from "../HOC/withRouter";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { get_YMD_from_SYS } from "../SystemUtility/SystemUtility";

class AMCUnblock extends Component {
  state = {
    formData: {
      dtpUnblockDate: get_YMD_from_SYS(new Date()),
      cmbUnblockBy: "",
      txtRemark: "",
    },
    unblockByList: [{ name: "Customer" }, { name: "Management" }],
  };

  componentDidMount() {
    document.title = "AMC Unblock";
    localStorage.setItem("Heading", "AMC Unblock");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
  }

  getInfo = () => {
    document.getElementById("dtpUnblockDate").focus();
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  unblockAMC = () => {
    const { dtpUnblockDate, cmbUnblockBy } = this.state.formData;
    if (!dtpUnblockDate) {
      this.props.toastErrorMsg("Select Unblock Date", "dtpUnblockDate");
      return;
    }
    if (!cmbUnblockBy) {
      this.props.toastErrorMsg("Select Unblock By", "cmbUnblockBy");
      return;
    }
    this.props.toastMsg("success", "AMC Unblocked Successfully");
    this.clearInfo();
  };

  clearInfo = () => {
    this.setState({
      formData: {
        ...this.state.formData,
        // dtpUnblockDate: "",
        cmbUnblockBy: "",
        txtRemark: "",
      },
    });
  };

  render() {
    const { formData } = this.state;
    return (
      <form>
        <Grid container spacing={2} marginTop={2}>
          <Grid item>
            <CtDtp
              id="dtpUnblockDate"
              label="Date*"
              value={formData.dtpUnblockDate}
              handleOnChange={this.handleOnChange}
              width={180}
              onKeyDown={this.props.onKeyDown}
              maxLength={100}
              nextCtrlID={"cmbUnblockBy"}
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbUnblockBy"
              label="Unblock By*"
              items={this.state.unblockByList}
              colID="name"
              value={formData.cmbUnblockBy}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={100}
              nextCtrlID={"txtRemark"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
          <Grid item>
            <CtMultiLineText
              id="txtRemark"
              label="Remark"
              value={formData.txtRemark}
              handleOnChange={this.handleOnChange}
              width={520}
              maxLength={1000}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
          <Grid item>
            <CtBtn
              label="Unblock"
              className="secondary-button"
              onClick={this.unblockAMC}
            />
          </Grid>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  const navigate = useNavigate();
  return <AMCUnblock {...props} navigate={navigate} />;
}

export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
